import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { IProjectData } from "hooks/api/GQL/project/useProjectData.models";
import { IRelianceMetadata } from "models/projects.models";
import { ProjectStatus, ProjectType } from "utils/constants/project.constants";
import {
  getProjectStatuses,
  getRelianceProjectStatuses,
} from "./useProjectStatusOptions.utils";

export type TProjectStatusOption = {
  id: ProjectStatus;
  label: string;
  disabled?: boolean;
  adornment?: ReactNode | null;
};

const useProjectStatusOptions = (
  project: IProjectData | null | undefined,
): TProjectStatusOption[] => {
  const { t } = useTranslation("projects");

  switch (project?.type) {
    case ProjectType.Reliance:
      return getRelianceProjectStatuses(
        project as IProjectData<IRelianceMetadata>,
        t,
      );

    case ProjectType.RegulatoryReview:
    case ProjectType.SharedWorkspace:
      return getProjectStatuses(project, t);

    default:
      return [];
  }
};

export default useProjectStatusOptions;
